module.exports = __webpack_public_path__ + "img/stylist-laserbeamer-desktop.webp";